import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import baseUrl from "../../../baseUrl";
import EmptyData from "../EmptyData/EmptyData";
import Spinner from "../../Spinner/Spinner";
import moment from "moment";
import BreadCrumb from "../../BreadCrumb/BreadCrumb";

const ListAllStudents = () => {
  const adminToken = JSON.parse(localStorage.getItem("EXAMNP:admin-token"));

  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(false);

  // for loading students list
  useEffect(() => {
    setLoading(true);
    axios
      .get(`${baseUrl}/admin/get-all-students`, {
        headers: { Authorization: `Bearer ${adminToken}` },
      })
      .then((res) => {
        if (res.data.success === true) {
          setStudents(res.data.students);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [adminToken]);

  return (
    <>
      {loading && <Spinner />}
      {students.length <= 0 ? (
        <EmptyData message="Sorry! students data not found." />
      ) : (
        <div className="container">
          <h3 className="text-gray-700 text-3xl font-bold">All Students</h3>
          <BreadCrumb
            textOne="Dashboard"
            linkOne="/admin/dashboard"
            textTwo="Batch"
            linkTwo="/admin/students"
            textThree="All Students"
          />
          <hr />
          <table className="table-auto w-full">
            <thead className="text-xs font-semibold uppercase text-gray-400 bg-gray-50">
              <tr>
                <th className="p-2">
                  <div className="font-semibold text-left">Reg.No.</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">S.Name</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">Batch No.</div>
                </th>

                <th className="p-2">
                  <div className="font-semibold text-left">S.Email</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">S.Address</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">Ph. No.</div>
                </th>

                <th className="p-2">
                  <div className="font-semibold text-left">Password</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">DOB</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">P. NAme</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">P. Num.</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">P. Relation.</div>
                </th>
              </tr>
            </thead>

            <tbody className="text-sm divide-y divide-gray-100">
              {students.map((student, index) => (
                <tr key={index}>
                  <td className="p-2">
                    <div className="mb-4 md:mr-2 md:mb-0">
                      <label className="block mb-2 text-sm font-medium text-blue-600">
                        {student.registrationNumber}
                      </label>
                    </div>
                  </td>
                  <td className="p-2">
                    <div className="mb-4 md:mr-2 md:mb-0 flex">
                      <img
                        src={student.studentPhoto.url}
                        className="mr-2 w-6 h-6 rounded-full"
                        alt="student_profile"
                      />
                      <label className="block mb-2 text-sm font-medium text-blue-600">
                        {student.studentName}
                      </label>
                    </div>
                  </td>
                  <td className="p-2">
                    <div className="mb-4 md:mr-2 md:mb-0">
                      <label className="block mb-2 text-sm font-medium text-blue-600">
                        {student.batchId.batchName}
                      </label>
                    </div>
                  </td>

                  <td className="p-2">
                    <div className="mb-4 md:mr-2 md:mb-0">
                      <label className="block mb-2 text-sm font-medium text-blue-600">
                        {student.studentEmail}
                      </label>
                    </div>
                  </td>
                  <td className="p-2">
                    <div className="font-medium text-blue-600">
                      {student.studentAddress}
                    </div>
                  </td>
                  <td className="p-2">
                    <div className="font-medium text-blue-600">
                      {student.studentPhoneNumber}
                    </div>
                  </td>
                  <td className="p-2">
                    <div className="font-medium text-blue-600">
                      {student.password}
                    </div>
                  </td>
                  <td className="p-2">
                    <div className="font-medium text-blue-600">
                      {moment(student.studentDOB).format("DD-MM-YYYY")}
                    </div>
                  </td>
                  <td className="p-2">
                    <div className="font-medium text-blue-600">
                      {student.parents.parentName}
                    </div>
                  </td>
                  <td className="p-2">
                    <div className="font-medium text-blue-600">
                      {student.parents.parentNumber}
                    </div>
                  </td>
                  <td className="p-2">
                    <div className="font-medium text-blue-600">
                      {student.parents.relation}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <hr />
    </>
  );
};

export default ListAllStudents;
